<og-notice-banner *ngIf="showBanner()" (dismiss)="closeBanner()">
  <strong>Expiration:</strong>
  Your subscription expires in <span class="font-bold">{{ daysLeft }}</span> days. Renew now to
  avoid interruption.
</og-notice-banner>
